// Extracted from original BrilliantGem.babylon at db4f4f67^
// 145 vertices, 64 faces
export const ORIGINAL_GEM_POSITIONS = new Float32Array([
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, 0.708861231803894,
  8.753858082855004e-9, 1.1519591680553276e-7, -0.44113874435424805,
  8.753858082855004e-9, -0.5411958694458008, 0.30886125564575195,
  8.753858082855004e-9, -0.5411958694458008, 0.30886125564575195,
  8.753858082855004e-9, -0.5411958694458008, 0.30886125564575195,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, -0.9238801002502441, -0.09113877266645432,
  8.753858082855004e-9, -0.8659138679504395, -0.2661387324333191,
  8.753858082855004e-9, -0.8659138679504395, -0.2661387324333191,
  8.753858082855004e-9, -0.8659138679504395, -0.2661387324333191,
  8.753858082855004e-9, -0.8659138679504395, -0.2661387324333191,
  0.22961004078388214, -0.5543279647827148, -0.44113874435424805,
  0.22961004078388214, -0.5543279647827148, -0.44113874435424805,
  0.22961004078388214, -0.5543279647827148, -0.44113874435424805,
  0.22961004078388214, -0.5543279647827148, -0.44113874435424805,
  0.38268303871154785, -0.38268375396728516, 0.30886125564575195,
  0.38268303871154785, -0.38268375396728516, 0.30886125564575195,
  0.38268303871154785, -0.38268375396728516, 0.30886125564575195,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.9238799810409546, -0.38268375396728516, -0.09113877266645432,
  0.612293004989624, -0.6122927665710449, -0.2661387324333191,
  0.612293004989624, -0.6122927665710449, -0.2661387324333191,
  0.612293004989624, -0.6122927665710449, -0.2661387324333191,
  0.612293004989624, -0.6122927665710449, -0.2661387324333191,
  0.5543279647827148, -0.22960996627807617, -0.44113874435424805,
  0.5543279647827148, -0.22960996627807617, -0.44113874435424805,
  0.5543279647827148, -0.22960996627807617, -0.44113874435424805,
  0.5543279647827148, -0.22960996627807617, -0.44113874435424805,
  0.5411959886550903, 1.1519591680553276e-7, 0.30886125564575195,
  0.5411959886550903, 1.1519591680553276e-7, 0.30886125564575195,
  0.5411959886550903, 1.1519591680553276e-7, 0.30886125564575195,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.9238799810409546, 0.3826831579208374, -0.09113877266645432,
  0.865913987159729, 1.1519591680553276e-7, -0.2661387324333191,
  0.865913987159729, 1.1519591680553276e-7, -0.2661387324333191,
  0.865913987159729, 1.1519591680553276e-7, -0.2661387324333191,
  0.865913987159729, 1.1519591680553276e-7, -0.2661387324333191,
  0.5543279647827148, 0.22961008548736572, -0.44113874435424805,
  0.5543279647827148, 0.22961008548736572, -0.44113874435424805,
  0.5543279647827148, 0.22961008548736572, -0.44113874435424805,
  0.5543279647827148, 0.22961008548736572, -0.44113874435424805,
  0.38268303871154785, 0.3826831579208374, 0.30886125564575195,
  0.38268303871154785, 0.3826831579208374, 0.30886125564575195,
  0.38268303871154785, 0.3826831579208374, 0.30886125564575195,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.38268303871154785, 0.9238801002502441, -0.09113877266645432,
  0.612293004989624, 0.6122931241989136, -0.2661387324333191, 0.612293004989624,
  0.6122931241989136, -0.2661387324333191, 0.612293004989624,
  0.6122931241989136, -0.2661387324333191, 0.612293004989624,
  0.6122931241989136, -0.2661387324333191, 0.22961004078388214,
  0.5543280839920044, -0.44113874435424805, 0.22961004078388214,
  0.5543280839920044, -0.44113874435424805, 0.22961004078388214,
  0.5543280839920044, -0.44113874435424805, 0.22961004078388214,
  0.5543280839920044, -0.44113874435424805, 8.753858082855004e-9,
  0.5411961078643799, 0.30886125564575195, 8.753858082855004e-9,
  0.5411961078643799, 0.30886125564575195, 8.753858082855004e-9,
  0.5411961078643799, 0.30886125564575195, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  0.9238801002502441, -0.09113877266645432, 8.753858082855004e-9,
  0.8659141063690186, -0.2661387324333191, 8.753858082855004e-9,
  0.8659141063690186, -0.2661387324333191, 8.753858082855004e-9,
  0.8659141063690186, -0.2661387324333191, 8.753858082855004e-9,
  0.8659141063690186, -0.2661387324333191, -0.22960995137691498,
  0.5543280839920044, -0.44113874435424805, -0.22960995137691498,
  0.5543280839920044, -0.44113874435424805, -0.22960995137691498,
  0.5543280839920044, -0.44113874435424805, -0.22960995137691498,
  0.5543280839920044, -0.44113874435424805, -0.38268303871154785,
  0.3826831579208374, 0.30886125564575195, -0.38268303871154785,
  0.3826831579208374, 0.30886125564575195, -0.38268303871154785,
  0.3826831579208374, 0.30886125564575195, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.9238799810409546,
  0.3826831579208374, -0.09113877266645432, -0.612293004989624,
  0.6122931241989136, -0.2661387324333191, -0.612293004989624,
  0.6122931241989136, -0.2661387324333191, -0.612293004989624,
  0.6122931241989136, -0.2661387324333191, -0.612293004989624,
  0.6122931241989136, -0.2661387324333191, -0.5543279647827148,
  0.22961008548736572, -0.44113874435424805, -0.5543279647827148,
  0.22961008548736572, -0.44113874435424805, -0.5543279647827148,
  0.22961008548736572, -0.44113874435424805, -0.5543279647827148,
  0.22961008548736572, -0.44113874435424805, -0.5411959886550903,
  1.1519591680553276e-7, 0.30886125564575195, -0.5411959886550903,
  1.1519591680553276e-7, 0.30886125564575195, -0.5411959886550903,
  1.1519591680553276e-7, 0.30886125564575195, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.9238799810409546,
  -0.38268375396728516, -0.09113877266645432, -0.865913987159729,
  1.1519591680553276e-7, -0.2661387324333191, -0.865913987159729,
  1.1519591680553276e-7, -0.2661387324333191, -0.865913987159729,
  1.1519591680553276e-7, -0.2661387324333191, -0.865913987159729,
  1.1519591680553276e-7, -0.2661387324333191, -0.5543279647827148,
  -0.22960996627807617, -0.44113874435424805, -0.5543279647827148,
  -0.22960996627807617, -0.44113874435424805, -0.5543279647827148,
  -0.22960996627807617, -0.44113874435424805, -0.5543279647827148,
  -0.22960996627807617, -0.44113874435424805, -0.38268303871154785,
  -0.38268375396728516, 0.30886125564575195, -0.38268303871154785,
  -0.38268375396728516, 0.30886125564575195, -0.38268303871154785,
  -0.38268375396728516, 0.30886125564575195, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.38268303871154785,
  -0.9238801002502441, -0.09113877266645432, -0.612293004989624,
  -0.6122927665710449, -0.2661387324333191, -0.612293004989624,
  -0.6122927665710449, -0.2661387324333191, -0.612293004989624,
  -0.6122927665710449, -0.2661387324333191, -0.612293004989624,
  -0.6122927665710449, -0.2661387324333191, -0.22960995137691498,
  -0.5543279647827148, -0.44113874435424805, -0.22960995137691498,
  -0.5543279647827148, -0.44113874435424805, -0.22960995137691498,
  -0.5543279647827148, -0.44113874435424805, -0.22960995137691498,
  -0.5543279647827148, -0.44113874435424805,
]);

export const ORIGINAL_GEM_INDICES = new Uint16Array([
  26, 1, 10, 26, 10, 14, 27, 16, 29, 32, 17, 38, 35, 15, 20, 35, 20, 24, 36, 25,
  40, 44, 3, 28, 44, 28, 30, 45, 33, 50, 51, 34, 55, 54, 31, 37, 54, 37, 42, 52,
  41, 58, 62, 2, 43, 62, 43, 47, 61, 46, 67, 68, 49, 72, 71, 48, 53, 71, 53, 59,
  70, 57, 76, 78, 0, 60, 78, 60, 65, 77, 63, 80, 81, 64, 87, 88, 66, 69, 88, 69,
  75, 86, 74, 91, 94, 4, 79, 94, 79, 82, 95, 84, 97, 100, 85, 106, 103, 83, 89,
  103, 89, 92, 104, 93, 108, 111, 6, 96, 111, 96, 98, 113, 101, 118, 119, 102,
  123, 121, 99, 105, 121, 105, 110, 120, 109, 126, 130, 7, 112, 130, 112, 115,
  129, 114, 135, 136, 117, 140, 139, 116, 122, 139, 122, 127, 138, 125, 144, 11,
  5, 128, 11, 128, 133, 9, 131, 12, 13, 132, 19, 21, 134, 137, 21, 137, 143, 18,
  142, 23, 22, 8, 141, 8, 22, 39, 8, 39, 56, 8, 56, 73, 8, 73, 90, 8, 90, 107,
  8, 107, 124, 8, 124, 141,
]);
export const ORIGINAL_GEM_NORMALS = new Float32Array([
  0.23909786343574524, 0.5770947933197021, 0.7808930277824402,
  0.23909786343574524, -0.5770947933197021, 0.7808930277824402,
  0.5770947933197021, 0.23909786343574524, 0.7808930277824402,
  0.5770947933197021, -0.23909786343574524, 0.7808930277824402,
  -0.23909786343574524, 0.5770947933197021, 0.7808930277824402,
  -0.23909786343574524, -0.5770947933197021, 0.7808930277824402,
  -0.5770947933197021, 0.23909786343574524, 0.7808930277824402,
  -0.5770947933197021, -0.23909786343574524, 0.7808930277824402, 0, 0, 1, 0,
  -0.7225832939147949, 0.6912840008735657, 0.23909786343574524,
  -0.5770947933197021, 0.7808930277824402, -0.23909786343574524,
  -0.5770947933197021, 0.7808930277824402, 0, -0.7225832939147949,
  0.6912840008735657, 0, -0.9492915272712708, -0.3143971860408783,
  0.23909786343574524, -0.5770947933197021, 0.7808930277824402,
  0.25199228525161743, -0.6083813309669495, -0.7525769472122192,
  0.510917067527771, -0.510917067527771, 0.6913229823112488, 0.6712449193000793,
  -0.6712449193000793, -0.31442102789878845, 0, -0.4896961450576782,
  -0.8718931674957275, 0, -0.9492915272712708, -0.3143971860408783,
  0.25199228525161743, -0.6083813309669495, -0.7525769472122192,
  -0.25199228525161743, -0.6083813309669495, -0.7525769472122192, 0, 0, 1, 0,
  -0.4896961450576782, -0.8718931674957275, 0.25199228525161743,
  -0.6083813309669495, -0.7525769472122192, 0.34629014134407043,
  -0.34629014134407043, -0.8718751668930054, 0.23909786343574524,
  -0.5770947933197021, 0.7808930277824402, 0.510917067527771,
  -0.510917067527771, 0.6913229823112488, 0.5770947933197021,
  -0.23909786343574524, 0.7808930277824402, 0.510917067527771,
  -0.510917067527771, 0.6913229823112488, 0.5770947933197021,
  -0.23909786343574524, 0.7808930277824402, 0.6083813309669495,
  -0.25199228525161743, -0.7525769472122192, 0.6712449193000793,
  -0.6712449193000793, -0.31442102789878845, 0.7225832939147949, 0,
  0.6912840008735657, 0.9492915272712708, 0, -0.3143971860408783,
  0.25199228525161743, -0.6083813309669495, -0.7525769472122192,
  0.34629014134407043, -0.34629014134407043, -0.8718751668930054,
  0.6083813309669495, -0.25199228525161743, -0.7525769472122192,
  0.6712449193000793, -0.6712449193000793, -0.31442102789878845, 0, 0, 1,
  0.34629014134407043, -0.34629014134407043, -0.8718751668930054,
  0.4896961450576782, 0, -0.8718931674957275, 0.6083813309669495,
  -0.25199228525161743, -0.7525769472122192, 0.5770947933197021,
  0.23909786343574524, 0.7808930277824402, 0.5770947933197021,
  -0.23909786343574524, 0.7808930277824402, 0.7225832939147949, 0,
  0.6912840008735657, 0.510917067527771, 0.510917067527771, 0.6913229823112488,
  0.5770947933197021, 0.23909786343574524, 0.7808930277824402,
  0.6083813309669495, 0.25199228525161743, -0.7525769472122192,
  0.6712449193000793, 0.6712449193000793, -0.31442102789878845,
  0.7225832939147949, 0, 0.6912840008735657, 0.9492915272712708, 0,
  -0.3143971860408783, 0.4896961450576782, 0, -0.8718931674957275,
  0.6083813309669495, 0.25199228525161743, -0.7525769472122192,
  0.6083813309669495, -0.25199228525161743, -0.7525769472122192,
  0.9492915272712708, 0, -0.3143971860408783, 0, 0, 1, 0.34629014134407043,
  0.34629014134407043, -0.8718751668930054, 0.4896961450576782, 0,
  -0.8718931674957275, 0.6083813309669495, 0.25199228525161743,
  -0.7525769472122192, 0.23909786343574524, 0.5770947933197021,
  0.7808930277824402, 0.510917067527771, 0.510917067527771, 0.6913229823112488,
  0.5770947933197021, 0.23909786343574524, 0.7808930277824402, 0,
  0.7225832939147949, 0.6912840008735657, 0, 0.9492915272712708,
  -0.3143971860408783, 0.23909786343574524, 0.5770947933197021,
  0.7808930277824402, 0.25199228525161743, 0.6083813309669495,
  -0.7525769472122192, 0.510917067527771, 0.510917067527771, 0.6913229823112488,
  0.6712449193000793, 0.6712449193000793, -0.31442102789878845,
  0.25199228525161743, 0.6083813309669495, -0.7525769472122192,
  0.34629014134407043, 0.34629014134407043, -0.8718751668930054,
  0.6083813309669495, 0.25199228525161743, -0.7525769472122192,
  0.6712449193000793, 0.6712449193000793, -0.31442102789878845, 0, 0, 1, 0,
  0.4896961450576782, -0.8718931674957275, 0.25199228525161743,
  0.6083813309669495, -0.7525769472122192, 0.34629014134407043,
  0.34629014134407043, -0.8718751668930054, 0, 0.7225832939147949,
  0.6912840008735657, 0.23909786343574524, 0.5770947933197021,
  0.7808930277824402, -0.23909786343574524, 0.5770947933197021,
  0.7808930277824402, 0, 0.7225832939147949, 0.6912840008735657, 0,
  0.9492915272712708, -0.3143971860408783, -0.23909786343574524,
  0.5770947933197021, 0.7808930277824402, -0.25199228525161743,
  0.6083813309669495, -0.7525769472122192, -0.510917067527771,
  0.510917067527771, 0.6913229823112488, -0.6712449193000793,
  0.6712449193000793, -0.31442102789878845, 0, 0.4896961450576782,
  -0.8718931674957275, 0, 0.9492915272712708, -0.3143971860408783,
  0.25199228525161743, 0.6083813309669495, -0.7525769472122192,
  -0.25199228525161743, 0.6083813309669495, -0.7525769472122192, 0, 0, 1, 0,
  0.4896961450576782, -0.8718931674957275, -0.25199228525161743,
  0.6083813309669495, -0.7525769472122192, -0.34629014134407043,
  0.34629014134407043, -0.8718751668930054, -0.23909786343574524,
  0.5770947933197021, 0.7808930277824402, -0.510917067527771, 0.510917067527771,
  0.6913229823112488, -0.5770947933197021, 0.23909786343574524,
  0.7808930277824402, -0.510917067527771, 0.510917067527771, 0.6913229823112488,
  -0.5770947933197021, 0.23909786343574524, 0.7808930277824402,
  -0.6083813309669495, 0.25199228525161743, -0.7525769472122192,
  -0.6712449193000793, 0.6712449193000793, -0.31442102789878845,
  -0.7225832939147949, 0, 0.6912840008735657, -0.9492915272712708, 0,
  -0.3143971860408783, -0.25199228525161743, 0.6083813309669495,
  -0.7525769472122192, -0.34629014134407043, 0.34629014134407043,
  -0.8718751668930054, -0.6083813309669495, 0.25199228525161743,
  -0.7525769472122192, -0.6712449193000793, 0.6712449193000793,
  -0.31442102789878845, 0, 0, 1, -0.34629014134407043, 0.34629014134407043,
  -0.8718751668930054, -0.4896961450576782, 0, -0.8718931674957275,
  -0.6083813309669495, 0.25199228525161743, -0.7525769472122192,
  -0.5770947933197021, 0.23909786343574524, 0.7808930277824402,
  -0.5770947933197021, -0.23909786343574524, 0.7808930277824402,
  -0.7225832939147949, 0, 0.6912840008735657, -0.510917067527771,
  -0.510917067527771, 0.6913229823112488, -0.5770947933197021,
  -0.23909786343574524, 0.7808930277824402, -0.6083813309669495,
  -0.25199228525161743, -0.7525769472122192, -0.6712449193000793,
  -0.6712449193000793, -0.31442102789878845, -0.7225832939147949, 0,
  0.6912840008735657, -0.9492915272712708, 0, -0.3143971860408783,
  -0.4896961450576782, 0, -0.8718931674957275, -0.6083813309669495,
  0.25199228525161743, -0.7525769472122192, -0.6083813309669495,
  -0.25199228525161743, -0.7525769472122192, -0.9492915272712708, 0,
  -0.3143971860408783, 0, 0, 1, -0.34629014134407043, -0.34629014134407043,
  -0.8718751668930054, -0.4896961450576782, 0, -0.8718931674957275,
  -0.6083813309669495, -0.25199228525161743, -0.7525769472122192,
  -0.23909786343574524, -0.5770947933197021, 0.7808930277824402,
  -0.510917067527771, -0.510917067527771, 0.6913229823112488,
  -0.5770947933197021, -0.23909786343574524, 0.7808930277824402, 0,
  -0.7225832939147949, 0.6912840008735657, 0, -0.9492915272712708,
  -0.3143971860408783, -0.23909786343574524, -0.5770947933197021,
  0.7808930277824402, -0.25199228525161743, -0.6083813309669495,
  -0.7525769472122192, -0.510917067527771, -0.510917067527771,
  0.6913229823112488, -0.6712449193000793, -0.6712449193000793,
  -0.31442102789878845, -0.25199228525161743, -0.6083813309669495,
  -0.7525769472122192, -0.34629014134407043, -0.34629014134407043,
  -0.8718751668930054, -0.6083813309669495, -0.25199228525161743,
  -0.7525769472122192, -0.6712449193000793, -0.6712449193000793,
  -0.31442102789878845, 0, 0, 1, 0, -0.4896961450576782, -0.8718931674957275,
  -0.25199228525161743, -0.6083813309669495, -0.7525769472122192,
  -0.34629014134407043, -0.34629014134407043, -0.8718751668930054,
]);
